import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';
import type { PolicyResponse } from '@http/queries/useCreatePolicy';

export type { PolicyResponse } from '@http/queries/useCreatePolicy';

/** All custom policies for the current user's organisation. */
export function useFetchPolicies() {
  return useQuery({
    queryKey: [api.policies],
    queryFn: () => fetchWrapper.get<PolicyResponse[]>(api.policies),
    // Always refetch when the policies page is (re)mounted so it's fresh on arrival.
    refetchOnMount: 'always',
  });
}
